import { render, staticRenderFns } from "./GreenBuildingCertificateTable.vue?vue&type=template&id=292d0b35&scoped=true&"
import script from "./GreenBuildingCertificateTable.vue?vue&type=script&lang=js&"
export * from "./GreenBuildingCertificateTable.vue?vue&type=script&lang=js&"
import style0 from "./GreenBuildingCertificateTable.vue?vue&type=style&index=0&id=292d0b35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d0b35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('292d0b35')) {
      api.createRecord('292d0b35', component.options)
    } else {
      api.reload('292d0b35', component.options)
    }
    module.hot.accept("./GreenBuildingCertificateTable.vue?vue&type=template&id=292d0b35&scoped=true&", function () {
      api.rerender('292d0b35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/components/GreenBuildingCertificateTable.vue"
export default component.exports